import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import DeltaWifi from './DeltaWifi';

const WrappedDeltaWifi = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <DeltaWifi {...props} />
    </Provider>
  );
};

WrappedDeltaWifi.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
  }).isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedSeats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedTime: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  latLng: PropTypes.shape({
    value: PropTypes.string,
  }),
  loadNotifyModal: PropTypes.func.isRequired,
  locationCode: PropTypes.string,
  onLogin: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  setDeltaPageLocation: PropTypes.func.isRequired,
  showSignupModal: PropTypes.func.isRequired,
  collections: PropTypes.shape({}),
  showAuthModal: PropTypes.func.isRequired,
};

WrappedDeltaWifi.defaultProps = {
  isMobile: false,
  latLng: null,
  locationCode: 'ny',
  selectedSeats: 2,
  collections: [],
};
export default WrappedDeltaWifi;
